import {Injectable} from "@angular/core";
import {HttpClientService} from "@app/lib/b2b-services/util/http-client.service";
import {AlertController} from "@ionic/angular/lazy";
import {VendorAppSettingsModel} from "@app/lib/b2b-constants/app-settings.constant";
import {environment} from "@src/environments/environment";
import {AppUpdateInfo} from "@capawesome/capacitor-app-update";

@Injectable({providedIn: 'root'})
export class AppSettingsService {

  isModalOpen: boolean;
  appUpdateInfoModule: any;
  appUpdateInfo: AppUpdateInfo;
  appSettings: VendorAppSettingsModel;

  constructor(
    private httpClientService: HttpClientService,
    private alertController: AlertController,
  ) {
  }

  checkMobileAppVersion(): void {
    console.log('api called ')
    this.httpClientService.get('vendor-app-settings', {}).subscribe({
      next: (appSettings: VendorAppSettingsModel) => {
        this.appSettings = appSettings;
        this.updateNow();
      },
      error: (error: Error) => {
        console.log('error while fetching app settings', error);
      }
    })
    // this.updateNow();
  }


  updateNow(): void {
    console.log('update now ')
    import('@capawesome/capacitor-app-update')
      .then((module) => {
        console.log('module', module);
        this.appUpdateInfoModule = module;

        module?.AppUpdate?.getAppUpdateInfo()
          .then((info: AppUpdateInfo) => {
            console.log('info in the app update ', info);
            this.appUpdateInfo = info;
            if (info?.updateAvailability === 2) {
              this.performImmediateAndroidUpdate();
            } else {
              if (this.appSettings) {
                this.verifyAndroidAppVersion();
              } else {
                setTimeout(() => {
                  if (this.appSettings) {
                    this.verifyAndroidAppVersion();
                  }
                }, 5000);
              }
            }
            this.verifyAndroidAppVersion();
          })
          .catch((e: any) => {
            console.log('Error in the update', e)
            this.verifyAndroidAppVersion();
          });
      })
      .catch((e) => {
        console.debug('AppUpdate module not available, fallback to Play Store', e);
        this.verifyAndroidAppVersion();
      });
  }


  private verifyAndroidAppVersion(): void {
    if (this.appUpdateInfo) {
      if (this.appUpdateInfo?.updateAvailability === 2) {
        this.performImmediateAndroidUpdate();
      }
    } else {
      /*if (
        (Number(this.appSettings?.androidVersion) !== Number(environment.androidAppVersion))
      ) {
        this.modalInitialize().then();
      }*/
      if (
        !this.appSettings?.supportedAndroidAppVersions?.includes(Number(environment?.androidAppVersion))
      ) {
        this.modalInitialize().then();
      }
    }
  }

  private openUrl(): void {
    const url = 'https://play.google.com/store/apps/details?id=in.bag2bag.dashboard';
    this.openUrlInNative(url);
  }


  openUrlInNative(url: string): void {
    import('@capacitor/app-launcher').then((module) => {
      module?.AppLauncher?.openUrl({
        url,
      }).then();
    });
  }

  private performImmediateAndroidUpdate(): void {
    if (this.appUpdateInfoModule?.AppUpdate) {
      this.appUpdateInfoModule.AppUpdate.performImmediateUpdate()
        .then(() => console.log('In-app update triggered'))
        .catch((err: any) => {
          console.error('In-app update failed, fallback to Play Store', err);
          this.verifyAndroidAppVersion();
        });
    } else {
      this.verifyAndroidAppVersion();
    }
  }


  async modalInitialize(appSettings?: VendorAppSettingsModel): Promise<void> {
    if (this.isModalOpen) {
      return;
    }

    this.isModalOpen = true;
    const modal: HTMLIonAlertElement = await this.alertController.create({
      cssClass: 'update-version-modal',
      header: 'Update Required',
      message: 'A new version of the app is available. Please update to continue using the app.',
      buttons: [
        {
          text: 'Update Now',
          cssClass: 'update-version',
          handler: () => {
            this.openUrl();
          },
        },
      ],
      backdropDismiss: false,
      keyboardClose: false,
    })

    await modal.present();
  }


}
